export * from "-!../../../../../../../../HistomicsUI/histomicsui/web_client/node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../HistomicsUI/histomicsui/web_client/node_modules/vue-loader/lib/index.js??vue-loader-options!./ColorPickerInput.vue?vue&type=template&id=65c96cfc&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./~/@girder/histomicsui/vue/components/ColorPickerInput.vue?vue&type=template&id=65c96cfc&scoped=true&
// module id = 63
// module chunks = 0